import { Divider, Typography } from "antd";
import { Trans } from "react-i18next";

import { HelpCenterButton } from "@/modules/help-center";
import { useMaintenancePage } from "@/modules/maintenance-page/maintenance-page.hook";
import { StaticLayout } from "@/ui/static-layout";

import "./maintenance-page.style.less";

const { Title, Paragraph } = Typography;

const SLIDES = [{ key: 1, src: "/images/maintenance/serveurs.webp" }];

const MaintenancePage = () => {
  const { startDate, endDate } = useMaintenancePage();

  return (
    <StaticLayout
      className="maintenance-page"
      slides={SLIDES}
      content={
        <div className="maintenance-page-content">
          <img src="/images/maintenance/gears.webp" />
          {/*  Use `<Trans />` here to allow `<br />` and `<strong>` tags */}
          <Trans parent={Title} i18nKey="global:maintenance.title" />
          {startDate && endDate ? (
            <Trans
              parent={Paragraph}
              i18nKey="global:maintenance.duration"
              values={{ startDate, endDate }}
            />
          ) : (
            <Trans parent={Paragraph} i18nKey="global:maintenance.noDuration" />
          )}
          <Trans parent={Paragraph} i18nKey="global:maintenance.description" />
          <Trans parent={Paragraph} i18nKey="global:maintenance.thanks" />
          <Divider />
          <Trans parent={Paragraph} i18nKey="global:maintenance.support" />
          <HelpCenterButton short />
        </div>
      }
    />
  );
};

export default MaintenancePage;
